import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IAttributes } from 'src/app/models/IAttributes';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { IAppointmentData } from 'src/app/models/IAppointmentDetails';
import { Defaults } from 'src/app/Utilities/defaults';
import { DatePipe } from '@angular/common';
import { formatDate } from '@angular/common';
import moment from 'moment';

@Component({
  selector: 'app-order-note-dialog',
  templateUrl: './order-note-dialog.component.html',
  styleUrls: ['./order-note-dialog.component.css']
})
export class OrderNoteDialogComponent implements OnInit {

  OrderInitiation: FormGroup;
  userList: IUserDetails[] = [];
  listName: string = "";
  Isadded: boolean = false;
  patId: number;
  public Appdetails: IAppointmentData;
  minDate = new Date();
  formErrors = {
    'locationName': '',
    'provider': '',
    'orderDate': '',
  };
  validationMessages = {
    'locationName': {
      'required': 'Location Name is required.',

    },
    'provider': {
      'required': 'Provider Name is required.'
    },
    'orderDate': {
      'required': 'Order Date  is required.',
    }
  };
  public lstLocations: ILocationDetails[];
  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<OrderNoteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IAppointmentData, public dialog: MatDialog, public sharedService: SharedService
    , private schedulerservice: SchedularServiceService, public datepipe: DatePipe
  ) {

    this.Appdetails = data;
    //  this.fetchdata();
  }



  ngOnInit() {
    this.OrderInitiation = this.fb.group({
      provider: ['', Validators.required],
      orderDate: ['', Validators.required],
      locationName: ['', Validators.required],
      PatientName: '',
    });
    this.OrderInitiation.markAllAsTouched();
    this.OrderInitiation.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.OrderInitiation);
    });

    this.getUserList();
    this.OrderInitiation.patchValue({
      PatientName: this.Appdetails.name,

    });
  }

  // fetchdata() {
  //   this.OrderInitiation.patchValue({
  //     PatientName: this.Appdetails.name,

  //   });
  // }
  onSubmit() {
    localStorage.removeItem("isBackBtnVisibleInVisitNotes");
    sessionStorage.setItem("locationWithoutApp", this.OrderInitiation.value.locationName);
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  getUserList(): void {
    this.sharedService.getAllUsersByRole("Doctor").subscribe(data => {
      this.userList = data;
    });

    this.schedulerservice.getLocations().subscribe(data => {
      this.lstLocations = data;
      this.lstLocations = this.lstLocations.filter(a => a.active == true)
    });

    // this.OrderInitiation.patchValue({
    //   orderDate: new Date()
    // })
  }

  logValidationErrors(group: FormGroup = this.OrderInitiation): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid
          && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }
  changeddate: any;
  getSelectedLocationDate() {
    this.changeddate = "";
    this.schedulerservice.getservercurrentdate().subscribe(async result => {
      await result;
      this.OrderInitiation.patchValue({
        orderDate: moment(result).toDate()
      });
    });
  }

  userId: string = '';
  getLocationsInfo(event: any) {
    this.lstLocations = [];
    this.userId = event.target.value;
    this.schedulerservice.getLocationsByprovider(encodeURIComponent(this.userId).toString()).subscribe(data => {
      this.lstLocations = data;
    });
  }
}

